import { FEATURE_BADGES, type FeatureBadgeKey } from './constants'

const launchDay = (featureKey: FeatureBadgeKey) => {
  const entry = FEATURE_BADGES[featureKey]
  return entry.kind === 'beta' ? null : entry.launchDate.slice(0, 10)
}

export type FeatureBadgeEventProps = {
  badge_feature_key: FeatureBadgeKey
  badge_type: string
  badge_launch_date: string | null
  badge_state: 'shown' | null
}

/**
 * Event fields for an A/B-tested badge. Send them in both arms: `badge_state`
 * says whether the pill was on screen (null whenever it isn't, including
 * always in the no-badge arm). The arm itself comes from `ld_context_id`.
 */
export const featureBadgeEventProps = (
  featureKey: FeatureBadgeKey,
  { pillShown }: { pillShown: boolean }
): FeatureBadgeEventProps => {
  const entry = FEATURE_BADGES[featureKey]
  return {
    badge_feature_key: featureKey,
    badge_type: entry.kind,
    badge_launch_date: launchDay(featureKey),
    badge_state: pillShown ? 'shown' : null,
  }
}

export type PageFeatureBadge = {
  feature_key: FeatureBadgeKey
  badge_type: string
  badge_state: 'shown'
  launch_date: string | null
}

/** One entry of the page view's `feature_badges`, for a badge on screen. */
export const pageFeatureBadge = (
  featureKey: FeatureBadgeKey
): PageFeatureBadge => {
  const entry = FEATURE_BADGES[featureKey]
  return {
    feature_key: featureKey,
    badge_type: entry.kind,
    badge_state: 'shown',
    launch_date: launchDay(featureKey),
  }
}
